import { DASHBOARD_COLUMNS, DashboardColumn } from '../constants/defaultColumns';
import { TherapyJobStatus } from '../enums/TherapyJobStatus';

export const columnNameByStatus = (status: TherapyJobStatus): DashboardColumn | null => {
  if (!status) {
    console.warn('No status provided to get column name');
    return null;
  }

  const columnKey: DashboardColumn | null = (Object.keys(DASHBOARD_COLUMNS) as DashboardColumn[]).find(
    (key: DashboardColumn) => {
      const column = DASHBOARD_COLUMNS[key];
      return column.includes(status) ? key : null;
    }
  );

  if (!columnKey || !DASHBOARD_COLUMNS[columnKey]) {
    return null;
  }

  return columnKey;
};
